module.exports = __webpack_public_path__ + "static/media/ms-white-logo.80da066c.svg";